import * as React from "react";
import {EventState} from "./interfaces/EventState";
import 'moment/locale/de';
import {EventHelper} from "./EventHelper";

interface BigCalendarDetailProps {
    event?: EventState;
    onLoaded: (event: EventState) => void;
    showDetails: boolean;
}

interface BigCalendarDetailState {
    event: EventState;
}

/**
 * Text Input Element
 */
export class BigCalendarDetail extends React.Component<BigCalendarDetailProps, BigCalendarDetailState> {

    state: {
        event: EventState
    };

    constructor(props: any) {
        super(props);

        this.state = {
            event: this.props.event,
        }

    }

    /**
     * set the events details. by async ajax call.
     * @param event
     */
    public setEventDetails = (event: any, calendarId: string) => {
        console.log('Loading Event Details')
        let urlParam = new URLSearchParams();
        urlParam.append("calendarId", calendarId + "");
        urlParam.append("action", "exchange_event_details");
        urlParam.append("id", event.id);
        fetch("/wp-admin/admin-ajax.php", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: urlParam,
            credentials: 'same-origin'
        })
            .then(res => res.json())
            .then(
                (result) => {
                    let event = {...this.state.event};
                    if (result && result.success) {
                        event.body = result.data.body;
                        event.html = result.data.html;
                        event.title = result.data.title;
                        event.attachments = result.data.attachments;
                        event.start = result.data.start && result.data.start.date ? result.data.start.date : null;
                        event.end = result.data.end && result.data.end.date ? result.data.end.date : null;
                        event.location = result.data.location;

                        console.log(event);
                    }
                    this.setState({event: event});
                    this.props.onLoaded(event);
                },
                (error) => {
                    this.props.onLoaded(undefined);
                    console.log(error);
                }
            )
    }

    /**
     * close popup.
     */
    public closePopup = () => {
        this.setState({event: undefined});
    };

    render() {
        console.log(this.state.event);
        return <div>
            {this.state.event && (
                <div className={"bigCalendarDetail"}>
                    <div className={"bigCalendarHeader"}>
                        <div className={"bigCalendarHeaderTitle"}>
                            {this.state.event.title}
                        </div>
                        <div className={"bigCalendarHeaderClose"}>
                            <i onClick={this.closePopup.bind(this)} className="fa fa-close"/>
                        </div>
                    </div>
                    <div className={"bigCalendarContent"}>
                        <div>
                            <div className={"bigCalendar50Inline"}>
                                <i className={"fa fa-clock-o"}/>
                                {EventHelper.getDateString(this.state.event.start, this.state.event.end)}
                            </div>
                            {this.state.event.location &&
                                <div className={"bigCalendar50Inline"}>
                                    <i className={"fa fa-location-arrow"}/>
                                    {this.state.event.location}
                                </div>
                            }
                        </div>
                        <div className={"bigCalendarContentBodyContainer"}>
                            <i className={"fa fa-inbox"}/>
                            <div className={"bigCalendarContentBody"}>
                                {this.state.event.body && this.props.showDetails &&
                                    <div dangerouslySetInnerHTML={{__html: this.state.event.html}}>
                                    </div>
                                }

                                {(!this.state.event.body || !this.props.showDetails) &&
                                    <div>{this.state.event.title}
                                    </div>}
                            </div>
                        </div>
                        {(this.state.event.attachments && this.state.event.attachments.length > 0) && (
                            <div className={"bigCalendarAttachment"}>
                                {this.state.event.attachments.map((attachment: any) => (
                                    <div key={attachment.id} className={"bigCalendar50Inline"}>
                                        <i className={"fa fa-file"}/>
                                        <div>
                                            <a download={attachment.name}
                                               href={'data:' + attachment.type + ';base64,' + attachment.content}>
                                                {attachment.name}
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </div>)}
                    </div>
                </div>
            )}</div>
    }

}
